import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=15c6a950&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/userprofile.css?vue&type=style&index=0&id=15c6a950&scoped=true&lang=css&"
import style1 from "@/assets/css/project.css?vue&type=style&index=1&id=15c6a950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6a950",
  null
  
)

export default component.exports